<template>
    <div>
        <div v-if="page_loading">
            <v-dialog v-model="page_loading" hide-overlay persistent>
                <div class="text-center">
                    <v-progress-circular
                        :size="200"
                        color="error"
                        indeterminate
                    >{{ use_language.loading }}</v-progress-circular>
                </div>
            </v-dialog>
        </div>

        <div v-if="loading">
            <v-dialog v-model="loading" persistent>
                <div class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="error"
                        indeterminate
                    ></v-progress-circular>
                </div>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import { get_languages } from "@/website/global_function";
export default {
    props: [
        'page_loading',
        'loading'
    ],
    data() {
        return {
            use_language: {},
        };
    },
    async created() {
        this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    },
    setup(props) {
        props.page_loading=false;
        props.loading=false;

    },
    methods: {
        get_languages,
    },
}
</script>

<style scoped>
    >>>.v-dialog {
        overflow-y: hidden;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
</style>